import * as React from 'react';
const ComponentListContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ComponentListContext.displayName = 'ComponentListContext';
}
export default ComponentListContext;